import React from 'react';
import MapCanvas from '../../MapCanvas';
import { createDefaultMapData, countSeats, countOccupied } from '../../seatingMapUtils';

const Classic = ({ mapData, title = 'מפת מושבים', showTitle = true }) => {
  const data = mapData || createDefaultMapData();
  const total = countSeats(data);
  const occupied = countOccupied(data);

  return (
    <div className="seating-map-wrapper">
      {showTitle && (
        <div className="seating-map-header">
          <span className="seating-map-title">{title}</span>
        </div>
      )}

      <div className="seating-map-body">
        <MapCanvas mapData={data} showNames />
      </div>

      <div className="seating-map-legend">
        <div className="seating-map-legend-item">
          <div className="seating-map-legend-dot" style={{ backgroundColor: data.colors.occupied }} />
          <span>תפוס ({occupied})</span>
        </div>
        <div className="seating-map-legend-item">
          <div className="seating-map-legend-dot" style={{ backgroundColor: data.colors.empty }} />
          <span>פנוי ({total - occupied})</span>
        </div>
      </div>
    </div>
  );
};

export default Classic;
